import { UploadId } from '../upload';
import { PathBuilder, ApiRoute, HttpMethod, Url } from '../common';
import { WorkflowStartResult } from '../external';
import { LocationId } from '../location';
import { IAuditDataWithChannel } from './audit';
import { IPublishImageRequest } from './image';
import { IPublishVideoRequestBackend } from './video';

export const MAX_FACEBOOK_COMMENT_CHARACTER_LENGTH = 8_000;
export const MAX_FACEBOOK_CAPTION_CHARACTER_LENGTH = 63_206;
export const MAX_FACEBOOK_HASHTAGS_COUNT = 30;
// Export const MAX_FACEBOOK_SCHEDULED_DAYS = 75; // To be revised as part of DSL-1707
export const MAX_FACEBOOK_SCHEDULED_HOURS = 672; // 672 hours = 28 days
export const MAX_INSTAGRAM_SCHEDULED_DAYS = 75;

export interface FacebookPublishData {
    description?: string;
    firstComment?: string;
    scheduledTime?: Date;
}

/**
 * @deprecated This type is used in the deprecated rest API
 */
export type PublishVideoToFacebookRequest = IPublishVideoRequestBackend<FacebookPublishData>;

/**
 * @deprecated This type is used in the deprecated rest API
 */
export type PublishPhotoToFacebookRequest = IPublishImageRequest<FacebookPublishData>;

export interface PublishImageToFacebookWorkflowInput {
    channelData: FacebookPublishData;
    uploadIds: UploadId[];
    auditData: IAuditDataWithChannel;
}

export function facebookPermalink(pageId: string, postId: string): Url {
    return Url.from(`https://www.facebook.com/permalink.php?id=${pageId}&story_fbid=${postId}`);
}

interface FacebookPublishBaseParams {
    locationId: LocationId;
}

const FACEBOOK_PUBLISH_API_ROOT = <T extends FacebookPublishBaseParams>(path: PathBuilder<T>) =>
    path.literal('publish').literal('facebook').literal('location').param('locationId');

export const FacebookPublishApi = {
    canPostToFacebookPageForLocation: new ApiRoute<{ result: boolean }, FacebookPublishBaseParams, void, void>(
        HttpMethod.Get,
        path => FACEBOOK_PUBLISH_API_ROOT(path).literal('hasAccess'),
    ),
    publishPhoto: new ApiRoute<WorkflowStartResult, FacebookPublishBaseParams, PublishPhotoToFacebookRequest, void>(
        HttpMethod.Post,
        path => FACEBOOK_PUBLISH_API_ROOT(path).literal('photo'),
    ),
    publishVideo: new ApiRoute<WorkflowStartResult, FacebookPublishBaseParams, PublishVideoToFacebookRequest, void>(
        HttpMethod.Post,
        path => FACEBOOK_PUBLISH_API_ROOT(path).literal('video'),
    ),
};
